export enum UserRank {
    DEFAULT = "DEFAULT",
    ADMIN = "ADMIN",
    MASTER = "MASTER"
}
